import React from 'react';

const CardMastercard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_16678_8308)">
        <path d="M0 0H20V20H0V0Z" fill="black" />
        <path
          d="M7.55534 13.6663C8.03685 13.6663 8.51365 13.5715 8.95851 13.3872C9.40337 13.203 9.80758 12.9329 10.1481 12.5924C10.4885 12.2519 10.7586 11.8477 10.9429 11.4028C11.1272 10.958 11.222 10.4812 11.222 9.99967C11.222 9.51816 11.1272 9.04136 10.9429 8.5965C10.7586 8.15164 10.4885 7.74743 10.1481 7.40695C9.80758 7.06647 9.40337 6.79638 8.95851 6.61212C8.51365 6.42785 8.03685 6.33301 7.55534 6.33301C6.58288 6.33301 5.65025 6.71932 4.96261 7.40695C4.27498 8.09458 3.88867 9.02721 3.88867 9.99967C3.88867 10.9721 4.27498 11.9048 4.96261 12.5924C5.65025 13.28 6.58288 13.6663 7.55534 13.6663Z"
          fill="#EB001B"
        />
        <path
          d="M12.444 13.6663C12.9255 13.6663 13.4023 13.5715 13.8472 13.3872C14.292 13.203 14.6963 12.9329 15.0367 12.5924C15.3772 12.2519 15.6473 11.8477 15.8316 11.4028C16.0158 10.958 16.1107 10.4812 16.1107 9.99967C16.1107 9.51816 16.0158 9.04136 15.8316 8.5965C15.6473 8.15164 15.3772 7.74743 15.0367 7.40695C14.6963 7.06647 14.292 6.79638 13.8472 6.61212C13.4023 6.42785 12.9255 6.33301 12.444 6.33301C11.4715 6.33301 10.5389 6.71932 9.85129 7.40695C9.16365 8.09458 8.77734 9.02721 8.77734 9.99967C8.77734 10.9721 9.16365 11.9048 9.85129 12.5924C10.5389 13.28 11.4715 13.6663 12.444 13.6663Z"
          fill="#F79E1B"
        />
        <path
          d="M9.99957 12.7333C10.3847 12.3898 10.6927 11.9686 10.9034 11.4975C11.114 11.0264 11.2225 10.516 11.2218 9.99993C11.2225 9.48387 11.114 8.9735 10.9034 8.50239C10.6927 8.03129 10.3847 7.61012 9.99957 7.2666C9.61462 7.61025 9.30671 8.03145 9.09607 8.50252C8.88542 8.9736 8.77681 9.48391 8.77735 9.99993C8.77659 10.516 8.88512 11.0264 9.09578 11.4975C9.30643 11.9686 9.61445 12.3898 9.99957 12.7333Z"
          fill="#FF5F00"
        />
      </g>
      <defs>
        <clipPath id="clip0_16678_8308">
          <path
            d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CardMastercard;
